import { AuthLayout } from "@app/shared/layouts";
import { Outlet } from "@remix-run/react";

export default function Auth() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
}
